var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAtlasIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81.727,
    height: 81.725,
    viewBox: "0 0 81.727 81.725",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    width: 59.108,
    height: 64.537,
    fill: "#a2ba5f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48",
    "data-name": "Group 48",
    transform: "translate(-456.637 -2034.068)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(470.822 2042.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M59.109,34.5c-.7,8.455-4.81,14.189-4.182,12.682.88-2.116-2.117-2.822-.53-14.461s3.351-9.524,3.351-9.524a27.05,27.05,0,0,1,1.1,4.365A32.269,32.269,0,0,0,3.927,9.627a12.781,12.781,0,0,0,.163,2.064c1.9,11.749,9.388,7.149,19.62.154a30.416,30.416,0,0,1,4.875-2.767,9.554,9.554,0,0,1,4.821-1.325,7.024,7.024,0,0,1,5.937,2.053,9.368,9.368,0,0,1,3.4,5.57A9.467,9.467,0,0,1,35.521,26.41a8.3,8.3,0,0,1-4.928-.06C21.191,23.594-1.98,20.724.137,48.587a14.094,14.094,0,0,0,1.005,3.094A32.269,32.269,0,0,0,59.109,34.5M13.8,50.765A11.364,11.364,0,1,1,27.141,59.73,11.364,11.364,0,0,1,13.8,50.765",
    transform: "translate(-0.001 0.001)",
    fill: "#a2ba5f"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M80.226,40.363A39.863,39.863,0,1,1,40.362.5,39.863,39.863,0,0,1,80.226,40.363Z",
    transform: "translate(457.138 2034.568)",
    fill: "none",
    stroke: "#231f20",
    strokeLinecap: "round",
    strokeWidth: 2,
    strokeDasharray: "5 7"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtlasIcon);
export default __webpack_public_path__ + "static/media/atlas-icon.bd20b37b54d46f010f91d9bd1b3eeba4.svg";
export { ForwardRef as ReactComponent };